<app-packaging-system-tree [packagingSystem]="packagingSystem" [isDarkTheme]="isDarkTheme" [includeRoot]="true"
  [includeComponents]="false" [deselectionAllowed]="false" (nodeSelected)="onNodeSelected($event)">
</app-packaging-system-tree>

<app-packaging-navigation [itemId]="packagingSystem.id" [callerLevelId]="packagingPartType"
  [callerTypeId]="packagingPart.System" [currentDirectoryId]="packagingSystem.directoryId" [brandName]="packagingSystem.brandName"
  [productName]="packagingSystem.productName" [articleNumber]="packagingSystem.articleNumber"
  [versionId]="packagingSystem.version" [isCurrentVersion]="packagingSystem.isCurrentVersion"
  [hasRecyclabilityResult]="packagingSystem.hasRecyclabilityResult" [hasLifeCycleResult]="packagingSystem.hasLifeCycleResult"
  [creationTimestamp]="packagingSystem.creationTimestamp">

    <div id="versions-container" *ngIf="!isUserValidator">
    <mat-form-field class="form-field-versions">
      <mat-label>{{ 'home.packagingUnitHome.historyVersion' | transloco }}</mat-label>
      <mat-select [(value)]="selectedExpenseResults" (selectionChange)="onSelectedVersionChanged()">
        <mat-option *ngFor="let analysisVersion of expenseResults" [value]="analysisVersion">
          {{ 'analysis.calculatedOn' | transloco }}
          {{ getDateTimeString(analysisVersion[0].evaluationReferenceTimestamp) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <span id="analysis-id">
      <ng-container *ngIf="selectedExpenseResults[0].licenseFee">
        {{ 'analysis.licenseFeeId' | transloco }}: <b>{{selectedExpenseResults[0].licenseFee.id}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="selectedExpenseResults[0].licenseFee.id">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="selectedExpenseResults[0].ecomodulation">
        {{ 'analysis.ecomodulationId' | transloco }}: <b>{{selectedExpenseResults[0].ecomodulation.id}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="selectedExpenseResults[0].ecomodulation.id">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="selectedExpenseResults[0].plasticTax">
        {{ 'analysis.plasticTaxId' | transloco }}: <b>{{selectedExpenseResults[0].plasticTax.id}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="selectedExpenseResults[0].plasticTax.id">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-container>

    </span>
  </div>

  <mat-tab-group dynamicHeight>
    <mat-tab [label]="'analysis.expenseCalculation.licenseFee.title' | transloco">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | transloco"></p>
        <app-expense-calculation-html-template [expenseResults]="dataSource" [displayType]="displayType.licenseFee" [packagingPart]="packagingSystem"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.licenseFee.title' | transloco"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.plasticTax.title' | transloco">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| transloco"></p>
        <app-expense-calculation-html-template [expenseResults]="dataSource" [displayType]="displayType.plasticTax" [packagingPart]="packagingSystem"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.plasticTax.title' | transloco"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.total.title' | transloco">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| transloco"></p>
        <app-expense-calculation-html-template [expenseResults]="dataSource" [displayType]="displayType.total" [packagingPart]="packagingSystem"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.total.title' | transloco"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>
  </mat-tab-group>



</app-packaging-navigation>
